export const breakpoints = {
  xxs: '320px',
  xs: '480px',
  sm: '768px',
  md: '992px',
  lg: '1200px',
};
